import { WifiOff, RefreshCw } from 'lucide-react'

export default function OfflineScreen() {
  const handleRetry = () => {
    window.location.reload()
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-100 to-gray-200 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full text-center">
        <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <WifiOff className="h-10 w-10 text-red-500" />
        </div>

        <h1 className="text-2xl font-bold text-gray-900 mb-2">
          Нет подключения к интернету
        </h1>

        <p className="text-gray-600 mb-6">
          Проверьте соединение и попробуйте снова.
          Для корректной работы системы необходим доступ к серверу.
        </p>

        <button
          onClick={handleRetry}
          className="inline-flex items-center justify-center space-x-2 w-full px-6 py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors"
        >
          <RefreshCw className="h-5 w-5" />
          <span>Попробовать снова</span>
        </button>

        <div className="mt-8 pt-6 border-t border-gray-200">
          <p className="text-sm text-gray-500 mb-2">Проблемы с доступом?</p>
          <a
            href="mailto:support@zionhub.ru"
            className="text-sm text-blue-600 hover:underline"
          >
            support@zionhub.ru
          </a>
        </div>
      </div>
    </div>
  )
}
